
import {
  AttributeDTO,
  InboxDTO,
  OrganizationalUnitDTO,
  ProfileDTO,
  ProfileRoleTYPE,
  ProtocolProfileDTO,
  ProtocolProfileType,
  TextRuleDTO,
  UserDTO
} from './../../api/plyca-dtos';

import { ActionParameterDefinitionDTO } from './../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { AcceptFormAction, CancelFormAction, FormAction, FormConfig, FormDialogResponse, TemplateDef } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { ProtocolDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { catchError, finalize, tap, map } from 'rxjs/operators';

import * as lodash from 'lodash';

import { HelpType } from '../../components/common/help/help.service';
import { searchGenericComponent, SearchSettingDTOModal } from '../../components/search/searchGeneric.component';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
export class ProtocolModel {

  dto: ProtocolDTO;
  ui: any;
}
export class TabledInbox {
  _parent: any;
  order: number;
  type: string;
  description: string;
  identifier: string;
  profile: ProfileDTO;

  textRules: Array<TextRuleDTO>;

}

export class TabledProfile {

  // Para cada línea de la tabla de protocoloPerfil
  // Una lista de buzones firmantes con sus reglas
  signerInboxs: Array<TabledInbox>;
  // Una lista de buzones tramitadores con sus reglas
  dispatcherInboxs: Array<TabledInbox>;
  // El protocolo y el perfil asociados a la
  protocolProfile: ProtocolProfileDTO;


}
@Component({
  selector: 'protocol-form',
  templateUrl: 'protocol.edition.template.html',
  providers: [DialogService]
})
export class ProtocolEditionComponent
  extends BaseFormComponent<ProtocolDTO, ProtocolModel>
  implements OnInit, OnDestroy {

  @ViewChild('profilesTemplate') profilesTemplate: TemplateRef<any>;

  private identifier: string;
  readonly = false;
  operation: string;
  private properties = {};
  private organismohex: string;
  private application: string;
  CANCEL_ACTION: any;

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.operation = dialogConfig['operation'];
    this.organismohex = dialogConfig['organismohex'];
    this.application = dialogConfig['application'];
    this.readonly = this.operation && this.operation == 'show';
    this.windowHash = generateRandomIdentifier();

  }

  ngOnInit(): void {
    this.subscribe(


      this.propertyService.getProperty('PROTOCOLO.DEFINIDOS_TRAMITADORES')
        .pipe(catchError((error: any) => {
          console.log(error)
          return of(undefined)
        })

        ).pipe(
          tap(
            (prop: any[]) => {
              this.properties['PROTOCOLO.DEFINIDOS_TRAMITADORES'] = prop[0]?.toUpperCase() == 'S';

            }),
          finalize(() => {
            super.ngOnInit();
          })
        )
    )
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    formConfig.searchTags = [HelpType.EDIT_PROTOCOL];

    let profilesTDef = new TemplateDef();
    profilesTDef.identifier = 'profilesTemplate';
    profilesTDef.template = this.profilesTemplate;
    formConfig.templates.push(profilesTDef);


    formConfig.functions.push({
      identifier: 'userSearch',
      fn: this.openUserSelector
    });

    formConfig.functions.push({
      identifier: 'inboxSearch',
      fn: this.openInboxSelector
    });

    formConfig.functions.push({
      identifier: 'attributeSearch',
      fn: this.openAttributSelector
    });

    formConfig.functions.push({
      identifier: 'rules',
      fn: this.profileRules
    });

    formConfig.functions.push({
      identifier: 'copy',
      fn: this.copy
    });







    return of(formConfig);
  }




  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'admin/protocolISettings.json';
  }

  getServiceURL(operation?: string): string {
    return this.configuration.PROTOCOL_SERVICE_URL;
  }
  getObjectParams(): { [param: string]: string | string[]; } {
    return {
      'expand': 'expansionSet:manage'
    };
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: ProtocolDTO): Observable<any> {
    let model = new ProtocolModel();
    // inicializacion de los campos del modelo utilizados por el json

    model.dto = dto;
    model['ui'] = {};

    model.ui.properties = this.properties;
    model.ui['operation'] = this.operation;

    if (this.operation === 'insert') {
      model.dto.organizationalUnit = new OrganizationalUnitDTO();
      // model.dto.organizationalUnit.name = this.organismohex;
      model.dto.organizationalUnit.identifier = this.organismohex;
      model.dto.application = this.application;
      this.normalizeTabledProfileElements(model);
      return of(model)
    } else {

      return this.plycaService
        .get<ProtocolDTO>(
          this.configuration.PROTOCOL_ALLPROFILES,
          model.dto.identifier,
          {
            'expand': 'expansionSet:manage'
          }
        )
        .pipe(
          map((result) => {
            console.log(result)
            model.dto.protocolProfiles = result.protocolProfiles;
            this.normalizeTabledProfileElements(model);
            if (this.operation == 'copy') {
              model.dto.identifier = undefined;
              // model.dto.inboxes = [];
              // model.dto.userInboxes = [];
            }
            return model
          }),
          catchError((error: any) => {
            this.plycaErrorHandler.showServerError(error);
            return throwError(error);
          })
        )


    }

  }



  private normalizeTabledProfileElements(model: ProtocolModel) {
    model.ui['tabledProfiles'] = [];
    // a.profile.identifier
    model.dto.protocolProfiles.sort((a, b) => (a.profile.identifier > b.profile.identifier)
      ? 1 : (b.profile.identifier > a.profile.identifier)
        ? -1 : 0
    );

    let previous = '-123456789';
    // Se transforma el objeto a elemento de la tabla
    let tabledProfile = new TabledProfile();
    model.dto.protocolProfiles.forEach(item => {
      if (item.profile.identifier !== previous) {
        if (previous !== '-123456789') {
          model.ui.tabledProfiles.push(tabledProfile);
        }

        tabledProfile = new TabledProfile();
        tabledProfile.signerInboxs = [];
        tabledProfile.dispatcherInboxs = [];
        tabledProfile.protocolProfile = item;
      }

      let empty = false;
      switch (item.profileRole) {
        case ProfileRoleTYPE.SIGNER: {

          let tabledInbox = new TabledInbox();
          tabledInbox.profile = item.profile;
          tabledInbox.order = item.order;
          tabledInbox.textRules = item.textRules;
          switch (item.protocolProfileType) {
            case ProtocolProfileType.INBOX: {
              tabledInbox.description = item.inbox.name;
              tabledInbox.identifier = item.inbox.identifier;
              tabledInbox.type = ProtocolProfileType.INBOX;
              break;
            }
            case ProtocolProfileType.ATTRIBUTE: {
              tabledInbox.description = item.attribute.identifier;
              tabledInbox.identifier = item.attribute.identifier;
              tabledInbox.type = ProtocolProfileType.ATTRIBUTE;
              break;
            }
            default:
              empty = true;
          }
          if (!empty) {
            tabledProfile.signerInboxs.push(tabledInbox);
          }

          break;
        }

        case ProfileRoleTYPE.DISPATCHER: {

          let tabledInbox = new TabledInbox();
          switch (item.protocolProfileType) {

            case ProtocolProfileType.INBOX: {
              tabledInbox.description = item.inbox.name;
              tabledInbox.identifier = item.inbox.identifier;
              tabledInbox.type = ProtocolProfileType.INBOX;
              break;
            }

            case ProtocolProfileType.ATTRIBUTE: {
              tabledInbox.description = item.attribute.description;
              tabledInbox.identifier = item.attribute.identifier;
              tabledInbox.type = ProtocolProfileType.ATTRIBUTE;
              break;
            }
            default:
              empty = true;
          }
          if (!empty) {
            tabledProfile.dispatcherInboxs.push(tabledInbox);
          }
        }
      }



      previous = item.profile.identifier;
    });

    if (previous !== model.ui.tabledProfiles[model.ui.tabledProfiles.length - 1].protocolProfile.profile.identifier) {
      model.ui.tabledProfiles.push(tabledProfile);
    }
  }

  modelToDTO(model: ProtocolModel): ProtocolDTO {

    // TODO
    /*
    3.9	BBDD
El mantenimiento de protocolos utiliza 2 tablas para consolidar la información:
•	PROTOCOLO: Definición del protocolo
•	PROTOCOLOPERFIL: Perfiles-Buzones de un protocolo
Debemos tener en cuenta, que la columna USUID contiene identificadores de buzones y atributos


this.model.ui.tabledProfiles[0].signerInboxs
*/

    // Se transforma el elemento de la tabla al objeto
    let protocolSignerProfileList = [];
    model.ui.tabledProfiles.forEach(tableItem1 => {

      tableItem1.signerInboxs.forEach(inboxItem => {
        if (inboxItem.type !== undefined) {

          let item = new ProtocolProfileDTO();
          /*
          protocol: ProtocolDTO;
          profile: ProfileDTO;
          order: number;
          attribute: AttributeDTO;
          inbox: InboxDTO;
          -protocolProfileType: ProtocolProfileType;
          -profileRole: ProfileRoleTYPE;
          textRules: Array<TextRuleDTO>;
          */
          item.protocolProfileType = inboxItem.type;
          // this.model.ui.tabledProfiles[0].profile.textRules
          item.profile = tableItem1.protocolProfile.profile;
          item.profileRole = ProfileRoleTYPE.SIGNER;
          item.order = inboxItem.order;
          switch (inboxItem.type) {

            case ProtocolProfileType.INBOX: {
              item.inbox = {} as InboxDTO;
              item.inbox.name = inboxItem.description;
              item.inbox.identifier = inboxItem.identifier;
              item.textRules = inboxItem.textRules;
              break;
            }

            case ProtocolProfileType.ATTRIBUTE: {
              item.attribute = {} as AttributeDTO;
              item.attribute.description = inboxItem.identifier;
              item.attribute.identifier = inboxItem.identifier;
              item.textRules = inboxItem.textRules;
              break;
            }

            default:
              console.log('NOP')
          }


          protocolSignerProfileList.push(item);
        }



      });

    });

    model.dto.protocolProfiles = [...protocolSignerProfileList];

    // Se transforma el elemento de la tabla al objeto
    let protocolDispatcherProfileList = [];
    this.model.ui.tabledProfiles.forEach(tableItem2 => {


      tableItem2.dispatcherInboxs.forEach(inboxItem => {
        if (inboxItem.type !== undefined) {

          let item = new ProtocolProfileDTO();
          item.protocolProfileType = inboxItem.type;
          item.profile = tableItem2.protocolProfile.profile;
          item.profileRole = ProfileRoleTYPE.DISPATCHER;
          item.textRules = tableItem2.protocolProfile.textRules;



          switch (inboxItem.type) {

            case ProtocolProfileType.INBOX: {
              item.inbox = {} as InboxDTO;
              item.inbox.name = inboxItem.description;
              item.inbox.identifier = inboxItem.identifier;
              item.textRules = inboxItem.textRules;
              break;
            }

            case ProtocolProfileType.ATTRIBUTE: {
              item.attribute = {} as AttributeDTO;
              item.attribute.description = inboxItem.description;
              item.attribute.identifier = inboxItem.identifier;
              item.textRules = inboxItem.textRules;

              break;
            }

            default:
              console.log('NOP')
          }


          protocolDispatcherProfileList.push(item);
        }


      });


    });

    model.dto.protocolProfiles = [...protocolSignerProfileList, ...protocolDispatcherProfileList];



    let dto: ProtocolDTO;
    dto = lodash.cloneDeep(model.dto);
    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;

  }

  updateProtocol() {
    this.subscribe(this.update(),
      (newProtocol: ProtocolDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
          'success');
        this.ref.close(newProtocol);
      },
      (err) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
          'error');
        // Revisar ¿error de validación? Error 404
        // this.plycaErrorHandler.showServerError(err);
      })
  }
  confirmUpdate() {
    let mensaje = 'ControlPanel.protocols.confirm.update';

    setTimeout(() => {
      this.confirmationService.confirm({
        message: this.translationService.instant(mensaje),
        accept: () => {
          this.updateProtocol();
        }
      });
    }, 200);
  }


  initHeaderActions() {
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary',
          true, this.windowHash),
        (success) => {
          if (this.operation == 'insert' || this.operation == 'copy') {
            this.insertProtocol();
          } else {
            this.confirmUpdate();
          }
        }
      );

      this.subscribe(this.headerActionsService
        .addWindowAction('General.cancel', 'fas fa-times', 'btn-outline-secondary',
          true, this.windowHash),

        (success) => {

          this.cancel();


        });


    }
  }
  insertProtocol() {
    this.subscribe(this.insert(),
      (newProtocol: ProtocolDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
          'success');
        this.ref.close(newProtocol);
      },
      (err) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
          'error');
        // Revisar ¿error de validación? Error 404
        // this.plycaErrorHandler.showServerError(err);
      })
  }







  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  public cancel() {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );
    this.ref.close();

  }
  public noImplemented() {
    this.uiService.showSuccess(
      'Operación no implementada',
      this.translate.instant('General.info'),
      'warn'
    );

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    throw new Error('Method not implemented.');
  }


  mapInboxResult(model: any, result: any) {

    if (result && result[0]) {

      // Si ya hay elementos se filtran los que ya existen para no duplicar
      if (model.dto.userInboxes) {

        let r = result.filter(f => {
          if (!model.dto.userInboxes.find(i => i.inbox.identifier === f.identifier)) {
            return f;
          }
        })

        result.splice(0);
        result.push(...r);
      }

      // Map to userInbox
      result.forEach(row => {
        row['conditional'] = false;
        row['inbox'] = {};
        //  row['user'] = {};
        row.inbox['identifier'] = row.identifier;
        row.inbox['description'] = row.description;
        //  row.user['identifier'] = model?.dto;
        let arrayKeysExcept = ['inbox', 'conditional'];

        Object.keys(row).forEach(
          function (key) {
            if (arrayKeysExcept.indexOf(key) === -1) {
              delete row[key];
            }
          });

      });

    } else {
      result['inbox'] = {};
      //  result['user'] = {};

      result.inbox['identifier'] = result.identifier;
      result.inbox['description'] = result.description;
      //  result.user['identifier'] = model?.dto;
    }



  }


  // copia buzon con reglas
  copy(row: TabledInbox) {
    // this -> Es formElement
    let _model = this;

    let newRow = lodash.cloneDeep(row);
    newRow.order = undefined;
    newRow.textRules.forEach((rule) => {
      rule.identifier = undefined;
    }

    );

    if (_model['jsonField'] === 'signerInboxs') {
      //  tabledInbox.order = row.signerInboxs.length + 1;
      row._parent.signerInboxs.push(newRow);
      row._parent.signerInboxs = [...row._parent.signerInboxs];

    } else if (_model['jsonField'] === 'dispatcherInboxs') {
      // tabledInbox.order = row.dispatcherInboxs.length + 1;
      row._parent.dispatcherInboxs.push(newRow);
      row._parent.dispatcherInboxs = [...row._parent.dispatcherInboxs];


    }
  }


  // Buscadores


  openInboxSelector(row: any) {
    // this -> Es formElement
    let _model = this;


    // TODO
    // Buscador de buzones
    // Parametros: organismo y perfil
    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'ORGANISMO.RUTA';
    param1.value = row?._parent?.dto?.organizationalUnit?.identifier;
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    parametersURL.push(param1);
    let contextSearch = new SearchSettingDTOModal(
      'INBOXV2',
      true,
      parametersURL
    );

    let config: DynamicDialogConfig = {
      header: 'ControlPanel.protocols.searcher.inboxs',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, inbox => {

      let tabledInbox = new TabledInbox();
      tabledInbox.type = ProtocolProfileType.INBOX;
      tabledInbox.description = inbox.description
      tabledInbox.identifier = inbox.identifier;



      if (_model['jsonField'] === 'signerInboxs') {
        //  tabledInbox.order = row.signerInboxs.length + 1;
        row.signerInboxs.push(tabledInbox);
        row.signerInboxs = [...row.signerInboxs];

      } else if (_model['jsonField'] === 'dispatcherInboxs') {
        // tabledInbox.order = row.dispatcherInboxs.length + 1;
        row.dispatcherInboxs.push(tabledInbox);
        row.dispatcherInboxs = [...row.dispatcherInboxs];


      }


      return row;
    });

  }


  openUserSelector(row: any) {
    // this -> Es formElement
    let _model = this;

    // TODO
    /*
    3.7.3.1	Buscador de usuarios. Unidad orgánica y perfil informados.
    */

    let contextSearch = new SearchSettingDTOModal(
      'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios',
      true

    );
    contextSearch.searchConfig.expansion = 'expansionSet:manage';

    let config: DynamicDialogConfig = {
      header: 'ControlPanel.protocols.searcher.persons',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, (user: UserDTO) => {
      let mainInbox = user.userInboxes.find(inbox => inbox.main);
      //row.profile.profile.description = 'kk person';
      let tabledInbox = new TabledInbox();
      tabledInbox.type = ProtocolProfileType.INBOX;

      tabledInbox.description = mainInbox.inbox.name;
      tabledInbox.identifier = mainInbox.inbox.identifier;

      tabledInbox.profile = row.protocolProfile.profile;
      if (_model['jsonField'] === 'signerInboxs') {
        // tabledInbox.order = row.signerInboxs.length + 1;
        row.signerInboxs.push(tabledInbox);
        row.signerInboxs = [...row.signerInboxs];

      } else if (_model['jsonField'] === 'dispatcherInboxs') {
        // tabledInbox.order = row.dispatcherInboxs.length + 1;
        row.dispatcherInboxs.push(tabledInbox);
        row.dispatcherInboxs = [...row.dispatcherInboxs];
      }


      return row;
    });

  }

  openAttributSelector(row: any) {

    // this -> Es formElement
    let _model = this;
    let contextSearch = new SearchSettingDTOModal(
      'BuscadorAtributos',
      false
    );

    let config: DynamicDialogConfig = {
      header: 'ControlPanel.protocols.searcher.attribute',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, attrib => {
      if (attrib) {
        //row.profile.profile.description = 'kk';
        let tabledInbox = new TabledInbox();
        tabledInbox.type = ProtocolProfileType.ATTRIBUTE;
        tabledInbox.description = attrib.identifier
        tabledInbox.identifier = attrib.identifier;
        tabledInbox.profile = row.protocolProfile.profile;

        if (_model['jsonField'] === 'signerInboxs') {
          // tabledInbox.order = row.signerInboxs.length + 1;
          row.signerInboxs.push(tabledInbox);
          row.signerInboxs = [...row.signerInboxs];


        } else if (_model['jsonField'] === 'dispatcherInboxs') {
          // tabledInbox.order = row.dispatcherInboxs.length + 1;
          row.dispatcherInboxs.push(tabledInbox);

          row.dispatcherInboxs = [...row.dispatcherInboxs];

        }

      }



      return row;
    });

  }

  profileRules(rowData?: TabledProfile, editable = true) {
    // this -> Es formElement
    let _model = this;

    const config1 = {
      header: this.translationService.instant('ControlPanel.protocols.actions.rules'),
      width: '90%',
      styleClass: 'formEdition',
      closable: true,
      closeOnEscape: true,
      baseZIndex: 1510
    } as DynamicDialogConfig;
    //let data = lodash.cloneDeep(rowData);


    let actions = new Array<FormAction<any>>();
    if (editable || !rowData) {
      actions.push(new AcceptFormAction());
      actions.push(new CancelFormAction());

    }
    if (editable === undefined) {
      editable = true;
    }

    config1['formConfig'] = new FormConfig(undefined,
      'admin/profileRulesISettings.json',
      rowData,
      actions,
      false,
      false, [HelpType.PROTOCOL_RULES], !editable
    );
    config1['readonly'] = !editable;

    const dialogRef = this.dialogService.open(formPlycaComponent, config1);
    this.subscribe(dialogRef.onClose, (response: FormDialogResponse<any>) => {
      if (response && response.actionId !== this.CANCEL_ACTION.actionId) {
        // this.emitUpdate(rowData, response.model);

        return response.model;
      }
    },
      (error: any) => {
        const ref = this.plycaErrorHandler.showServerError(error);
        this.subscribe(ref.onClose);


        console.log(error);
      }
    );
  }





}
